/**
 * WBK Produktvergleich - Vergleichsleiste + Vergleichsseite
 * outlander-lb.shop | generiert 2026-08-25
 */
(function () {
  'use strict';

  var MAX_COMPARE = 4;
  // Mobil: max. 3 Produkte (bessere Übersicht im Hochformat)
  function getMaxCompare() {
    return MAX_COMPARE; // immer 4, auch auf Mobile (Scrollen erlaubt)
  }
  var STORAGE_KEY = 'wbk_compare_v1';
  var COMPARE_URL  = '/pages/waermebild-vergleich';

  // ─────────────────────────────────────────────
  // UTILS
  // ─────────────────────────────────────────────
  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function setList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_COMPARE))); }
    catch (e) {}
  }
  function formatPrice(cents) {
    return (cents / 100).toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '\u00a0€';
  }

  // ─────────────────────────────────────────────
  // A) VERGLEICHSLEISTE (Produktseiten)
  // ─────────────────────────────────────────────
  function injectBarStyles() {
    if (document.getElementById('wbk-bar-styles')) return;
    var s = document.createElement('style');
    s.id = 'wbk-bar-styles';
    s.textContent = [
      '#wbk-cbar{position:fixed;bottom:-120px;left:0;right:0;z-index:9999;background:#1a1a1a;box-shadow:0 -4px 20px rgba(0,0,0,.25);transition:bottom .3s cubic-bezier(.4,0,.2,1)}',
      '#wbk-cbar.wbk-cbar--visible{bottom:0}',
      '.wbk-cbar__inner{max-width:1400px;margin:0 auto;padding:.75rem 1.5rem;display:flex;align-items:center;justify-content:space-between;gap:1rem;flex-wrap:wrap}',
      '.wbk-cbar__left{display:flex;align-items:center;gap:.75rem;flex:1;min-width:0}',
      '.wbk-cbar__label{font-size:.78rem;color:#aaa;text-transform:uppercase;letter-spacing:.06em;white-space:nowrap}',
      '.wbk-cbar__slots{display:flex;gap:.5rem}',
      '.wbk-cbar__slot{background:#2a2a2a;border:1.5px solid #444;border-radius:6px;width:90px;height:52px;display:flex;align-items:center;justify-content:center;position:relative;overflow:hidden;flex-shrink:0}',
      '.wbk-cbar__slot--empty{border-style:dashed;border-color:#555;color:#555;font-size:1.2rem}',
      '.wbk-cbar__img{width:100%;height:100%;object-fit:contain;padding:4px;background:#fff;border-radius:4px}',
      '.wbk-cbar__remove{position:absolute;top:2px;right:2px;background:rgba(0,0,0,.6);border:none;color:#fff;width:16px;height:16px;border-radius:50%;font-size:.6rem;cursor:pointer;display:none;align-items:center;justify-content:center;line-height:1}',
      '.wbk-cbar__slot:hover .wbk-cbar__remove{display:flex}',
      '.wbk-cbar__right{display:flex;align-items:center;gap:.75rem;flex-shrink:0}',
      '.wbk-cbar__btn{background:#2d7a3a;color:#fff;border:none;border-radius:6px;padding:.6rem 1.2rem;font-size:.88rem;font-weight:700;cursor:pointer;white-space:nowrap;transition:background .15s}',
      '.wbk-cbar__btn:hover:not(:disabled){background:#236030}',
      '.wbk-cbar__btn:disabled{background:#444;color:#888;cursor:not-allowed}',
      '.wbk-cbar__clear{background:none;border:none;color:#888;font-size:.78rem;cursor:pointer;white-space:nowrap}',
      '.wbk-cbar__clear:hover{color:#ccc}',
      '.wbk-add-btn{display:inline-flex;align-items:center;gap:.4rem;background:transparent;border:1.5px solid #2d7a3a;color:#2d7a3a;border-radius:6px;padding:.5rem 1rem;font-size:.88rem;font-weight:600;cursor:pointer;margin-top:.75rem;transition:background .15s,color .15s;width:100%;justify-content:center}',
      '.wbk-add-btn:hover,.wbk-add-btn--active{background:#2d7a3a;color:#fff}',
      '@media(max-width:640px){.wbk-cbar__slot{width:60px;height:44px}.wbk-cbar__label{display:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function initBar() {
    var dataEl = document.getElementById('wbk-product-meta');
    if (!dataEl) return; // Kein WBK-Produkt
    injectBarStyles();

    var handle = dataEl.dataset.handle;
    var title  = dataEl.dataset.title;
    var image  = dataEl.dataset.image;
    var price  = parseInt(dataEl.dataset.price, 10) || 0;

    // Bar-HTML einmalig erstellen
    var bar = document.createElement('div');
    bar.id = 'wbk-cbar';
    bar.innerHTML = [
      '<div class="wbk-cbar__inner">',
        '<div class="wbk-cbar__left">',
          '<span class="wbk-cbar__label">Vergleichen:</span>',
          '<div class="wbk-cbar__slots" id="wbk-cbar-slots"></div>',
        '</div>',
        '<div class="wbk-cbar__right">',
          '<button class="wbk-cbar__btn" id="wbk-cbar-go" disabled>⚖️ Jetzt vergleichen</button>',
          '<button class="wbk-cbar__clear" id="wbk-cbar-clear">Alle entfernen</button>',
        '</div>',
      '</div>',
    ].join('');
    document.body.appendChild(bar);

    // Button: aktuelles Produkt hinzufügen
    var addBtn = document.getElementById('wbk-add-btn');
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var list = getList();
        var idx  = list.findIndex(function (p) { return p.handle === handle; });
        if (idx >= 0) {
          // Entfernen (toggle)
          list.splice(idx, 1);
        } else {
          if (list.length >= getMaxCompare()) {
            alert('Du kannst maximal ' + getMaxCompare() + ' Produkte gleichzeitig vergleichen. Entferne zuerst ein Produkt.');
            return;
          }
          list.push({ handle: handle, title: title, image: image, price: price });
        }
        setList(list);
        renderBar();
      });
    }

    document.getElementById('wbk-cbar-go').addEventListener('click', function () {
      var list = getList();
      if (list.length < 2) return;
      var handles = list.map(function (p) { return p.handle; }).join(',');
      window.location.href = COMPARE_URL + '?compare=' + handles;
    });

    document.getElementById('wbk-cbar-clear').addEventListener('click', function () {
      setList([]);
      renderBar();
    });

    renderBar();

    function renderBar() {
      var list    = getList();
      var inList  = list.some(function (p) { return p.handle === handle; });
      var slotsEl = document.getElementById('wbk-cbar-slots');
      var goBtn   = document.getElementById('wbk-cbar-go');
      var barEl   = document.getElementById('wbk-cbar');

      // Slots rendern
      var html = '';
      list.forEach(function (p) {
        html += '<div class="wbk-cbar__slot">';
        if (p.image) html += '<img src="' + p.image + '" alt="" class="wbk-cbar__img">';
        html += '<span class="wbk-cbar__name">' + escHtml(p.title.split(' ').slice(0, 4).join(' ')) + '</span>';
        html += '<button class="wbk-cbar__remove" data-handle="' + escHtml(p.handle) + '" title="Entfernen">✕</button>';
        html += '</div>';
      });

      // Leere Slots
      for (var i = list.length; i < getMaxCompare(); i++) {
        html += '<div class="wbk-cbar__slot wbk-cbar__slot--empty"><span>+</span></div>';
      }
      slotsEl.innerHTML = html;

      // Remove-Buttons
      slotsEl.querySelectorAll('.wbk-cbar__remove').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var h = this.dataset.handle;
          var l = getList().filter(function (p) { return p.handle !== h; });
          setList(l);
          renderBar();
        }.bind(btn));
      });

      // CTA-Button
      goBtn.disabled = list.length < 2;
      goBtn.textContent = '⚖️ Jetzt vergleichen (' + list.length + ')';

      // Bar zeigen/verstecken
      barEl.classList.toggle('wbk-cbar--visible', list.length > 0);

      // Hinzufügen-Button auf Produktseite aktualisieren
      var ab = document.getElementById('wbk-add-btn');
      if (ab) {
        ab.classList.toggle('wbk-add-btn--active', inList);
        ab.textContent = inList ? '✓ Im Vergleich' : '⚖️ Zum Vergleich hinzufügen';
      }
    }
  }

  // ─────────────────────────────────────────────
  // B) VERGLEICHSSEITE
  // ─────────────────────────────────────────────
  function initComparePage() {
    var root = document.getElementById('wbk-vergleich-root');
    if (!root) return;

    var params  = new URLSearchParams(window.location.search);
    var raw     = params.get('compare') || '';
    var handles = raw.split(',').map(function(h){ return h.trim(); }).filter(Boolean);

    // Aus localStorage ergänzen falls URL leer
    if (handles.length === 0) {
      handles = getList().map(function(p){ return p.handle; });
    }

    if (typeof window.WBK_DATA === 'undefined') {
      root.innerHTML = '<p class="wbk-vgl__error">Produktdaten werden geladen...</p>';
      return;
    }

    renderPage(root, handles);
  }

  function renderPage(root, handles) {
    var data = window.WBK_DATA;

    // Validiere Handles
    var valid = handles.filter(function(h){ return !!data[h]; });

    // ─── PRODUKT-PICKER ───
    var pickerHtml = buildPicker(data, valid);

    if (valid.length === 0) {
      root.innerHTML = pickerHtml + '<p class="wbk-vgl__hint">Wähle 2-4 Geräte aus, um sie zu vergleichen.</p>';
      bindPicker(root, data, valid);
      return;
    }

    // ─── VERGLEICHSTABELLE ───
    var products = valid.map(function(h){ return data[h]; });
    var tableHtml = buildTable(products);

    root.innerHTML = pickerHtml + tableHtml;
    bindPicker(root, data, valid);

    // Live-Preise nachziehen
    fetchLivePrices(valid, root);
  }

  // Spec-Gruppen Definition (Keys aus Shopify API verifiziert 2026-08-25)
  var SPEC_GROUPS = [
    { label: '\uD83C\uDF21\uFE0F Sensor', rows: [
      { key: 'specs.sensor_h',    label: 'Aufl\u00f6sung',     unit: '',           best: 'higher_px', composite: 'sensor_v' },
      { key: 'specs.pitch_um',    label: 'Pixel-Pitch',         unit: '\u00a0\u03bcm',  best: 'none' },
      { key: 'specs.netd',        label: 'NETD',                unit: '\u00a0mK',   best: 'lower' },
      { key: 'specs.bildfreq',    label: 'Bildfrequenz',        unit: '\u00a0Hz',   best: 'higher' },
    ]},
    { label: '\uD83D\uDD0D Optik', rows: [
      { key: 'specs.objektiv_mm', label: 'Brennweite',          unit: '\u00a0mm',   best: 'none' },
      { key: 'specs.fov_h',       label: 'Sichtfeld (H)',       unit: '\u00b0',     best: 'higher' },
      { key: 'specs.fov_v',       label: 'Sichtfeld (V)',       unit: '\u00b0',     best: 'none' },
      { key: 'specs.sehfeld_100m',label: 'Sehfeld bei 100\u00a0m', unit: '\u00a0m',best: 'higher' },
      { key: 'specs.zoom_opt',    label: 'Opt. Vergr.',         unit: 'x',          best: 'none' },
      { key: 'specs.zoom_ges',    label: 'Max. Vergr.',         unit: 'x',          best: 'higher' },
      { key: 'specs.tag_nachtsicht', label: 'Tag- & Nachtsicht',   unit: '',           best: 'none', bool: true },
      { key: 'specs.tag_nacht_aufloesung', label: 'Opt. Kanalauflösung', unit: '', best: 'none' },
    ]},
    { label: '\uD83D\uDDA5\uFE0F Display', rows: [
      { key: 'specs.display',     label: 'Typ',                 unit: '',           best: 'none' },
      { key: 'specs.display_aufl',label: 'Aufl\u00f6sung',      unit: '',           best: 'none' },
    ]},
    { label: '\uD83D\uDD0B Akku', rows: [
      { key: 'specs.akku_h',      label: 'Laufzeit',            unit: '\u00a0h',    best: 'higher' },
      { key: 'specs.akku_typ',    label: 'Typ',                 unit: '',           best: 'none' },
    ]},
    { label: '\uD83D\uDEE1\uFE0F Geh\u00e4use', rows: [
      { key: 'specs.ip',          label: 'Schutzklasse',        unit: '',           best: 'none' },
      { key: 'specs.gewicht_g',   label: 'Gewicht',             unit: '\u00a0g',    best: 'lower' },
    ]},
    { label: '\u2699\uFE0F Features', rows: [
      { key: 'specs.wifi',        label: 'WLAN / WiFi',         unit: '',           best: 'none', bool: true },
      { key: 'specs.app',         label: 'App',                 unit: '',           best: 'none', bool: true },
      { key: 'specs.lrf',         label: 'Entfernungsmesser',   unit: '',           best: 'none', bool: true },
      { key: 'specs.foto',        label: 'Foto',                unit: '',           best: 'none', bool: true },
      { key: 'specs.video',       label: 'Video',               unit: '',           best: 'none', bool: true },
      { key: 'specs.speicher_gb', label: 'Speicher',            unit: '\u00a0GB',   best: 'higher' },
      { key: 'specs.farbpaletten',label: 'Farbpaletten',        unit: '',           best: 'higher' },
    ]},
    { label: '\uD83E\uDD8C Wildreichweiten (Outlander-Berechnung)', rows: [
      { key: 'calc.detektion_m',  label: 'Detektion',           unit: '\u00a0m',    best: 'higher', calc: true },
      { key: 'calc.erk_rot_m',    label: 'Erkennung Rotwild',   unit: '\u00a0m',    best: 'higher', calc: true },
      { key: 'calc.ans_rot_m',    label: 'Ansprechen Rotwild',  unit: '\u00a0m',    best: 'higher', calc: true },
      { key: 'calc.erk_reh_m',    label: 'Erkennung Reh',       unit: '\u00a0m',    best: 'higher', calc: true },
      { key: 'calc.ans_reh_m',    label: 'Ansprechen Reh',      unit: '\u00a0m',    best: 'higher', calc: true },
    ]},
  ];

  function getVal(product, keyPath) {
    var parts = keyPath.split('.');
    var obj   = product;
    for (var i = 0; i < parts.length; i++) {
      if (obj == null) return null;
      obj = obj[parts[i]];
    }
    return obj != null ? obj : null;
  }

  function buildTable(products) {
    var cols = products.length;
    var isMobile = window.innerWidth <= 640;
    var LABEL_W = isMobile ? 110 : 170;
    var PROD_W  = isMobile ? 128 : 220;
    var tableMinW = LABEL_W + cols * PROD_W; // z.B. 2 Geräte mobile = 366px
    var html = '<div class="wbk-vgl__table-wrap"><table class="wbk-vgl__table" style="min-width:' + tableMinW + 'px">'; // min-width nur als Untergrenze

    // ─── COLGROUP: explizite Spaltenbreiten für table-layout:fixed ───
    html += '<colgroup><col style="width:' + LABEL_W + 'px">';
    for (var c = 0; c < cols; c++) {
      html += '<col style="width:' + PROD_W + 'px">';
    }
    html += '</colgroup>';

    // ─── HEADER: Produkt-Karten ───
    html += '<thead><tr><th class="wbk-vgl__th-label"></th>';
    products.forEach(function(p) {
      var discount = p.price_compare > p.price ? p.price_compare : 0;
      html += '<th class="wbk-vgl__th-product">';
      html += '<div class="wbk-vgl__prod-card">';
      if (p.image) html += '<img src="' + escHtml(p.image) + '" alt="' + escHtml(p.title) + '" class="wbk-vgl__prod-img">';
      html += '<div class="wbk-vgl__prod-title">' + escHtml(p.title) + '</div>';
      html += '<div class="wbk-vgl__prod-price" data-handle="' + escHtml(p.handle) + '">';
      if (discount > 0) {
        html += '<span class="wbk-vgl__price-old">' + formatPrice(discount) + '</span> ';
      }
      html += '<span class="wbk-vgl__price-now">' + formatPrice(p.price) + '</span>';
      html += '</div>';
      html += '<div class="wbk-vgl__action" data-handle="' + escHtml(p.handle) + '" data-url="' + escHtml(p.url) + '">';
      html += '<a href="' + escHtml(p.url) + '" class="wbk-vgl__prod-link">Zum Produkt →</a>';
      html += '</div>';
      html += '</div>';
      html += '</th>';
    });
    html += '</tr></thead>';

    // ─── BODY: Spec-Gruppen ───
    html += '<tbody>';
    SPEC_GROUPS.forEach(function(group) {
      // Gruppenzeile
      html += '<tr class="wbk-vgl__group-row"><td colspan="' + (cols + 1) + '" class="wbk-vgl__group-label">' + group.label + '</td></tr>';

      group.rows.forEach(function(row) {
        // Werte für alle Produkte sammeln
        var values = products.map(function(p) { return getVal(p, row.key); });

        // Prüfen ob Zeile relevant ist (mind. 1 Produkt hat Wert)
        var hasAny = values.some(function(v) { return v !== null && v !== undefined && v !== ''; });
        if (!hasAny) return;

        // Best-Highlighting: ALLE Produkte mit Bestwert markieren (nicht nur das erste)
        var bestIdxs = [];
        if (row.best === 'higher' || row.best === 'lower') {
          var nums = values.map(function(v) { return parseFloat(String(v).replace(',', '.')) || null; });
          var validNums = nums.filter(function(n) { return n !== null; });
          if (validNums.length > 1) {
            var extreme = row.best === 'higher' ? Math.max.apply(null, validNums) : Math.min.apply(null, validNums);
            nums.forEach(function(n, i) { if (n !== null && n === extreme) bestIdxs.push(i); });
          }
        } else if (row.best === 'higher_px') {
          // Auflösung: sensor_h × sensor_v → Pixel-Anzahl
          var px = products.map(function(p) {
            var h = getVal(p, row.key);
            var v = row.composite ? getVal(p, 'specs.' + row.composite) : null;
            if (h && v) return parseInt(h) * parseInt(v);
            return null;
          });
          var validPx = px.filter(function(n) { return n !== null; });
          if (validPx.length > 1) {
            var maxPx = Math.max.apply(null, validPx);
            px.forEach(function(n, i) { if (n !== null && n === maxPx) bestIdxs.push(i); });
          }
        }

        html += '<tr class="wbk-vgl__row">';
        html += '<td class="wbk-vgl__td-label' + (row.calc ? ' wbk-vgl__td-calc' : '') + '">' + row.label + '</td>';
        values.forEach(function(v, i) {
          var cls = 'wbk-vgl__td-val';
          if (bestIdxs.indexOf(i) >= 0) cls += ' wbk-vgl__td-best';
          var display;
          // Composite: sensor_h × sensor_v
          if (row.composite && v !== null) {
            var v2 = getVal(products[i], 'specs.' + row.composite);
            display = (v && v2) ? escHtml(String(v) + '\u202f\u00d7\u202f' + String(v2)) : '<span class="wbk-vgl__na">-</span>';
          } else {
            display = formatVal(v, row);
          }
          html += '<td class="' + cls + '">' + display + '</td>';
        });
        html += '</tr>';
      });
    });
    html += '</tbody></table></div>';

    // Fußnote
    html += '<p class="wbk-vgl__footnote">🦌 Wildreichweiten basieren auf Outlander-Berechnungen nach Johnson-Kriterien. Herstellerangaben können abweichen.</p>';

    // Action-Bar
    html += '<div class="wbk-vgl__action-bar">';
    html += '<button class="wbk-vgl__action-btn" id="wbk-vgl-reset">&#8635; Neu starten</button>';
    html += '<button class="wbk-vgl__action-btn wbk-vgl__action-btn--primary" id="wbk-vgl-share">&#8599; Ergebnis teilen</button>';
    html += '<button class="wbk-vgl__action-btn" id="wbk-vgl-recommend">♥ Vergleich weiterempfehlen</button>';
    html += '<a class="wbk-vgl__action-btn wbk-vgl__action-btn--secondary" href="/pages/waermebild-berater">🎯 Wärmebild-Berater starten</a>';
    html += '</div>';

    return html;
  }

  function formatVal(v, row) {
    if (v === null || v === undefined || v === '') return '<span class="wbk-vgl__na">-</span>';

    // Sensor-Auflösung: sensor_h × sensor_v zusammenbauen
    if (row.composite && v !== null) {
      // v = sensor_h Wert, aber wir wollen "HxV" anzeigen
      // Das wird in buildTable über die products-Referenz aufgelöst - hier nur Fallback
      return escHtml(String(v)) + (row.unit || '');
    }

    // Boolean
    if (row.bool) {
      if (v === true || v === 'true' || v === 1 || (typeof v === 'string' && v.toLowerCase() === 'ja')) {
        return '<span class="wbk-vgl__yes">✅</span>';
      }
      if (v === false || v === 'false' || v === 0 || (typeof v === 'string' && v.toLowerCase() === 'nein')) {
        return '<span class="wbk-vgl__no">❌</span>';
      }
      return escHtml(String(v));
    }

    // WLAN/App spezial
    if (typeof v === 'boolean') return v ? '<span class="wbk-vgl__yes">✅</span>' : '<span class="wbk-vgl__no">❌</span>';

    return escHtml(String(v)) + (row.unit || '');
  }

  function buildPicker(data, selected) {
    var allHandles = Object.keys(data).sort(function(a, b) {
      return data[a].title.localeCompare(data[b].title, 'de');
    });

    var brands = {};
    allHandles.forEach(function(h) {
      var b = data[h].brand || 'Sonstige';
      if (!brands[b]) brands[b] = [];
      brands[b].push(h);
    });

    var brandOrder = Object.keys(brands).sort();

    // Welche Marke soll initial offen sein?
    var openBrand = null;
    // Alle Akkordeon-Sektionen starten geschlossen – User öffnet selbst

    var html = '<div class="wbk-vgl__picker">';
    html += '<h2 class="wbk-vgl__picker-title">Geräte auswählen <span class="wbk-vgl__picker-hint">(2-4 Geräte, beliebige Hersteller)</span></h2>';

    // Ausgewählte Produkte - Chips oben
    html += '<div class="wbk-vgl__selected-bar">';
    if (selected.length > 0) {
      selected.forEach(function(h) {
        var shortTitle = data[h].title.replace(data[h].brand, '').trim().split(' ').slice(0, 5).join(' ');
        html += '<span class="wbk-vgl__chip">';
        html += '<span class="wbk-vgl__chip-brand">' + escHtml(data[h].brand) + '</span> ';
        html += escHtml(shortTitle);
        html += ' <button class="wbk-vgl__chip-remove" data-remove="' + escHtml(h) + '" title="Entfernen">✕</button>';
        html += '</span>';
      });
    } else {
      html += '<span class="wbk-vgl__chip-empty">Noch keine Geräte ausgewählt - klicke unten auf einen Hersteller</span>';
    }
    if (selected.length >= 2) {
      html += '<a class="wbk-vgl__share-btn" id="wbk-share-btn" href="#">🔗 Link teilen</a>';
    }
    html += '</div>';

    // Accordion
    html += '<div class="wbk-vgl__accordion">';
    brandOrder.forEach(function(brand) {
      var handles = brands[brand];
      var isOpen = brand === openBrand;
      var selCount = handles.filter(function(h) { return selected.indexOf(h) >= 0; }).length;
      var badge = selCount > 0 ? '<span class="wbk-vgl__acc-badge">' + selCount + '</span>' : '';

      html += '<div class="wbk-vgl__acc-item" data-brand="' + escHtml(brand) + '">';
      html += '<button class="wbk-vgl__acc-header' + (isOpen ? ' wbk-vgl__acc-header--open' : '') + '">';
      html += '<span class="wbk-vgl__acc-name">' + escHtml(brand) + badge + '</span>';
      html += '<span class="wbk-vgl__acc-count">' + handles.length + ' Geräte</span>';
      html += '<span class="wbk-vgl__acc-arrow">' + (isOpen ? '▲' : '▼') + '</span>';
      html += '</button>';

      html += '<div class="wbk-vgl__acc-body' + (isOpen ? ' wbk-vgl__acc-body--open' : '') + '">';
      handles.forEach(function(h) {
        var isSelected = selected.indexOf(h) >= 0;
        var shortTitle = data[h].title.replace(brand, '').trim();
        var cls = 'wbk-vgl__picker-item' + (isSelected ? ' wbk-vgl__picker-item--selected' : '');
        html += '<button class="' + cls + '" data-handle="' + escHtml(h) + '">';
        if (data[h].image) {
          html += '<img class="wbk-vgl__picker-img" src="' + escHtml(data[h].image) + '" alt="" loading="lazy">';
        }
        html += '<span class="wbk-vgl__picker-name">' + escHtml(shortTitle) + '</span>';
        if (isSelected) html += '<span class="wbk-vgl__picker-check">✓</span>';
        html += '</button>';
      });
      html += '</div>';
      html += '</div>'; // acc-item
    });
    html += '</div>'; // accordion
    html += '</div>'; // picker

    return html;
  }

  function bindPicker(root, data, currentSelected) {
    // Accordion-Toggle
    root.querySelectorAll('.wbk-vgl__acc-header').forEach(function(hdr) {
      hdr.addEventListener('click', function() {
        var item = this.closest('.wbk-vgl__acc-item');
        var body = item.querySelector('.wbk-vgl__acc-body');
        var arrow = this.querySelector('.wbk-vgl__acc-arrow');
        var isOpen = body.classList.contains('wbk-vgl__acc-body--open');
        if (isOpen) {
          body.classList.remove('wbk-vgl__acc-body--open');
          this.classList.remove('wbk-vgl__acc-header--open');
          arrow.textContent = '\u25bc';
        } else {
          body.classList.add('wbk-vgl__acc-body--open');
          this.classList.add('wbk-vgl__acc-header--open');
          arrow.textContent = '\u25b2';
        }
        // Accordion-State nach jedem Klick speichern
        var acc = item.closest('.wbk-vgl__accordion');
        var state = {};
        if (acc) {
          acc.querySelectorAll('.wbk-vgl__acc-item').forEach(function(it) {
            var b = it.dataset.brand;
            state[b] = it.querySelector('.wbk-vgl__acc-body').classList.contains('wbk-vgl__acc-body--open');
          });
        }
        try { sessionStorage.setItem('wbk_acc_state', JSON.stringify(state)); } catch(e) {}
      });
    });

    // Picker-Items
    root.querySelectorAll('.wbk-vgl__picker-item').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var h = this.dataset.handle;
        var sel = currentSelected.slice();
        var idx = sel.indexOf(h);
        if (idx >= 0) {
          sel.splice(idx, 1);
        } else {
          if (sel.length >= getMaxCompare()) {
            // Ältestes entfernen (max. 3 auf Mobil, 4 auf Desktop)
            sel.shift();
          }
          sel.push(h);
        }
        // URL aktualisieren + neu rendern
        var url = window.location.pathname + (sel.length > 0 ? '?compare=' + sel.join(',') : '');
        history.replaceState(null, '', url);
        // Comparison-Liste in localStorage synchronisieren
        var listData = sel.map(function(handle) {
          var p = data[handle];
          return { handle: handle, title: p.title, image: p.image, price: p.price };
        });
        setList(listData);
        renderPage(root, sel);
      }.bind(btn));
    });

    // Remove-Chips
    root.querySelectorAll('[data-remove]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var h = this.dataset.remove;
        var sel = currentSelected.filter(function(x){ return x !== h; });
        var url = window.location.pathname + (sel.length > 0 ? '?compare=' + sel.join(',') : '');
        history.replaceState(null, '', url);
        setList(sel.map(function(handle) {
          var p = data[handle];
          return { handle: handle, title: p ? p.title : handle, image: p ? p.image : '', price: p ? p.price : 0 };
        }));
        renderPage(root, sel);
      }.bind(btn));
    });

    // Share-Button (Chip-Leiste oben)
    var shareBtn = root.querySelector('#wbk-share-btn');
    if (shareBtn) {
      shareBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var url = window.location.href;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function() {
            shareBtn.textContent = '✅ Link kopiert!';
            setTimeout(function(){ shareBtn.textContent = '🔗 Link kopieren'; }, 2000);
          });
        } else {
          prompt('Vergleichslink:', url);
        }
      });
    }

    // ── Action-Bar (unten nach Tabelle) ──────────────────────────────
    // Neu starten
    var resetBtn = root.querySelector('#wbk-vgl-reset');
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        localStorage.removeItem('wbk_compare_v1');
        history.replaceState(null, '', window.location.pathname);
        setList([]);
        renderPage(root, []);
      });
    }

    // Ergebnis teilen
    var shareActionBtn = root.querySelector('#wbk-vgl-share');
    if (shareActionBtn) {
      shareActionBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var url = window.location.href;
        var text = 'Mein Wärmebildkamera-Vergleich bei Outlander LB – ' + url;
        if (navigator.share) {
          navigator.share({ title: 'Wärmebildkamera-Vergleich', text: text, url: url }).catch(function(){});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function() {
            shareActionBtn.textContent = '✅ Link kopiert!';
            setTimeout(function(){ shareActionBtn.textContent = '↗ Ergebnis teilen'; }, 2000);
          });
        } else {
          prompt('Vergleichslink kopieren:', url);
        }
      });
    }

    // Vergleich weiterempfehlen
    var recommendBtn = root.querySelector('#wbk-vgl-recommend');
    if (recommendBtn) {
      recommendBtn.addEventListener('click', function(e) {
        e.preventDefault();
        var url = window.location.pathname; // ohne ?compare=... → frischen Vergleich teilen
        var text = 'Schau mal – bei Outlander LB kannst du über 100 Wärmebildkameras direkt miteinander vergleichen: ' + window.location.origin + url;
        if (navigator.share) {
          navigator.share({ title: 'Wärmebildkameras vergleichen – Outlander LB', text: text, url: window.location.origin + url }).catch(function(){});
        } else if (navigator.clipboard) {
          navigator.clipboard.writeText(text).then(function() {
            recommendBtn.textContent = '✅ Link kopiert!';
            setTimeout(function(){ recommendBtn.textContent = '♥ Vergleich weiterempfehlen'; }, 2000);
          });
        } else {
          prompt('Empfehlungslink kopieren:', window.location.origin + url);
        }
      });
    }
  }

  // Discount-Tags wie im WBK-Berater → einheitliches Design
  var WBK_DISCOUNT_MAP = {
    'popup-wbk-50':  { code: 'WBK50',  amount: 50  },
    'popup-wbk-80':  { code: 'WBK80',  amount: 80  },
    'popup-wbk-100': { code: 'WBK100', amount: 100 }
  };

  function fetchLivePrices(handles, root) {
    // Preise + Discount-Codes via Shopify /products/handle.js aktualisieren
    handles.forEach(function(handle) {
      fetch('/products/' + handle + '.js')
        .then(function(r){ return r.json(); })
        .then(function(prod) {
          // ── Preis aktualisieren ──
          var priceEl = root.querySelector('.wbk-vgl__prod-price[data-handle="' + handle + '"]');
          if (priceEl) {
            var variants = prod.variants || [];
            if (variants.length) {
              var v = variants[0];
              var priceNow    = v.price;
              var priceBefore = v.compare_at_price;
              var priceHtml = '';
              if (priceBefore && priceBefore > priceNow) {
                priceHtml += '<span class="wbk-vgl__price-old">' + formatPrice(priceBefore) + '</span> ';
              }
              priceHtml += '<span class="wbk-vgl__price-now">' + formatPrice(priceNow) + '</span>';
              priceEl.innerHTML = priceHtml;
            }
          }
          // ── Discount-Code: Action-Button dynamisch setzen ──
          var actionEl = root.querySelector('.wbk-vgl__action[data-handle="' + handle + '"]');
          if (actionEl) {
            var tags = Array.isArray(prod.tags)
              ? prod.tags.map(function(t){ return t.trim(); })
              : (prod.tags || '').split(',').map(function(t){ return t.trim(); });
            var found = null;
            [100, 80, 50].forEach(function(amt) {
              if (!found && tags.indexOf('popup-wbk-' + amt) >= 0) {
                found = WBK_DISCOUNT_MAP['popup-wbk-' + amt];
              }
            });
            if (found) {
              var productUrl = actionEl.getAttribute('data-url') || '/products/' + handle;
              var priceNowCents = (prod.variants && prod.variants[0]) ? prod.variants[0].price : 0;
              var discountedCents = Math.max(0, priceNowCents - found.amount * 100);
              var applyUrl = '/discount/' + found.code + '?redirect=' + encodeURIComponent(productUrl);
              actionEl.innerHTML =
                '<div class="wbk-vgl__rabatt-label">Rabatt: ' + found.amount + '\u00a0\u20ac</div>' +
                '<div class="wbk-vgl__dein-preis">' + formatPrice(discountedCents) + '</div>' +
                '<a href="' + applyUrl + '" class="wbk-vgl__prod-link wbk-vgl__prod-link--code">Code anwenden \u2192</a>';
            }
          }
        })
        .catch(function(){});
    });
  }

  function escHtml(s) {
    return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // ─────────────────────────────────────────────
  // INIT
  // ─────────────────────────────────────────────
  function init() {
    if (document.getElementById('wbk-vergleich-root')) {
      // Wir sind auf der Vergleichsseite
      initComparePage();
    } else if (document.getElementById('wbk-product-meta')) {
      // Wir sind auf einer WBK-Produktseite
      initBar();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
